
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pay-fine",
      function () {
        return require("private-next-pages/pay-fine/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pay-fine"])
      });
    }
  